<template>
  <div>
    <Transaction
      :menu="{
        transactionName: value ? value.transactionName : null,
        selected: true,
        permission: permission,
      }"
      :environment="environment"
      :inputData="buildInputData(inputFields)"
      :session="session"
      :generalExApplicationEx="generalExApplicationEx"
      :customLanguage="customLanguage"
      :embeddedField="true"
      @update-notification="updateNotification"
      @load-transaction="loadTransaction"
      ref="transactionEmbedFieldRef"
    />
  </div>
</template>

<script>
export default {
  name: "EmbedField",
  props: [
    "id",
    "name",
    "access",
    "inputFields",
    "generalExApplicationEx",
    "customLanguage",
    "hint",
    "index",
    "environment",
    "screen",
    "session",
    "value",
    "dictionary",
    "permission",
    "formData",
    "coordinates",
  ],
  data() {
    return {};
  },
  components: {
    Transaction: () => import("./../Transaction"),
  },
  methods: {
    handleChange(data) {
      this.$emit("handle-change", data);
    },

    setValue(value, autoSource) {
      this.$refs.fieldRef.setValue(value, autoSource);
    },

    callEmbedField() {
      if (
        this.embedField(this.dictionary) &&
        this.dictionary.embedTransactionName
      ) {
        const isNull = !this.value;
        const isDifferent =
          this.value &&
          this.value.transactionName != this.dictionary.embedTransactionName;
        const isLoading = this.value && this.value.loading;

        if ((isNull || isDifferent) && !isLoading) {
          if (this.$refs.transactionEmbedFieldRef) {
            this.$refs.transactionEmbedFieldRef.callTransaction({
                transactionName: this.dictionary.embedTransactionName,
                selected: true,
                permission: this.permission,
              },
              null
            );
          }
        }
      }
    },
    updateNotification(data) {
      this.$emit("update-notification", data);
    },

    loadTransaction(args) {
      const data = {
        value: args,
        id: this.id,
        autoSource: null, //??
        coordinates: this.coordinates,
      };
      this.$emit("handle-change", data);
    },
  },
  updated() {
    this.callEmbedField();
  },
  mounted() {
  },
};
</script>

<style>
</style>